import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Button, Groupper, Header, Loader } from 'react-frontier2';
import API from '../../API';

var EventDateSeats = ()=>{
	var { t } = useTranslation();
	var params = useParams();
	var [loadError, setLoadError] = useState<string>(null);
	var [sections, setSections] = useState<{
		date_id: number,
		sections: {
			section_id: number,
			section_name: string,
			numbered: boolean,
			seats_url: string
		}[]
	}>(null);
	var [shownSections, setShownSections] = useState<number[]>([]);
	var date_id = useMemo(()=>{
		var par = params['*'];
		if(!par) return null;
		var spl = par.split('/');
		var d = spl[1];
		if(!d || Number.isNaN(parseInt(d))) return null;
		return parseInt(d);
	}, [params]);

	useEffect(()=>{
		if(!date_id || sections?.date_id===date_id) return;
		setLoadError(null);
		setSections(null);
		API.getDateSections(date_id, false, true).then(res=>{
			if(res.error) return setLoadError(res.message);
			setSections({
				date_id,
				sections: res.data
			});

			var numb = res.data.filter((a: typeof sections['sections'][0])=>!!a.numbered && !!a.seats_url);
			if(numb.length>0){
				setShownSections([numb[0].section_id]);
			}
		}).catch(err=>{
			setLoadError(t('common.unexpected_code', { code: 'LCL-EVDTSET-1' }));
		});
	}, [date_id]);

	var showNext = ()=>{
		if(!sections || !shownSections) return;
		var not_shown = sections.sections.filter(a=>!!a.numbered && !!a.seats_url && shownSections.indexOf(a.section_id)==-1);
		if(not_shown.length==0) return;
		setShownSections(a=>[...a, not_shown[0].section_id]);
	}

	var numbered_sections = useMemo(()=>{
		if(!sections) return [];
		return sections.sections.filter(a=>!!a.numbered);
	}, [sections]);

	if(!date_id) return null;
	if(!sections || loadError) return <Header text={loadError ? t('common.error') : t('common.loading')} loading={!loadError} subtext={loadError} />
	if(numbered_sections.length==0) return <Header text={t('event_reports.seatmap.empty_title')} subtext={t('event_reports.seatmap.empty_subtitle')} />

	return <div style={{ marginTop: 15 }}>
		{numbered_sections.map(a=>(
			<Groupper fitted 
				key={`SCTSMP-${a.section_id}`} 
				style={{ marginBottom: 15, maxWidth: 800 }} 
				title={a.section_name} 
				titleRight={(
					<Button text={t('common.download')} iconName={'arrow-down'} color={'black'} as={Link} to={a.seats_url+'/png'} target={'_blank'} />
				)}
			>
				{shownSections.indexOf(a.section_id)!==-1 ? (
					<img src={a.seats_url+'/svg'} onError={showNext} onLoad={showNext} style={{ height: 400, width: '100%', objectFit: 'contain' }} />
				) : (
					<div style={{ width: '100%', height: 400, padding: 15 }}>
						<Loader size={50} />
					</div>
				)}
			</Groupper>
		))}
	</div>
}

export default EventDateSeats;